import React from 'react'
import { withTranslation } from 'react-i18next'
import Card from '@material-ui/core/Card'
import Typography from '@material-ui/core/Typography'
import classNames from 'classnames'
import MyCheckmark from '../MyCheckmark'
import i18n from 'i18next'
import moment from 'moment'

function done({ showSpecificWaiverDate, operatorName, rideDate, t }) {
  const rideDateMoment = moment(rideDate).toDate()

  let localLocale = new Intl.DateTimeFormat(i18n.language, { month: 'long', day: 'numeric', year: 'numeric' }).format(
    rideDate ? rideDateMoment : new Date()
  )

  return (
    <Card className="center p-1 pr-2 mt-2 mb-2">
      <MyCheckmark className={classNames({ 'up-2': false })} style={{ width: '25%', maxWidth: '100px', margin: '0 auto' }} />
      <Typography variant="h6" className="pb-2">
        {t('allSetToRide', { operator: operatorName, interpolation: { escapeValue: false } })}
        {showSpecificWaiverDate && <div>{localLocale}</div>}
      </Typography>
      <Typography variant="h6" className="pb-2">
        {t('canCloseBrowser')}
      </Typography>
    </Card>
  )
}

export const Done = withTranslation()(done)
